export default __webpack_public_path__ + "static/media/avion_aterrizando.45031a6a.png";